import { Loader2 } from 'lucide-react'

/**
 * Generic route-transition fallback (`defaultPendingComponent`, ADR 0027) for destinations
 * without a layout-family skeleton. Routes that have one (workbench, table, dashboard,
 * document) set their own `pendingComponent` instead.
 */
export function RoutePending() {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
        minHeight: '40vh',
        color: 'var(--text-secondary)',
      }}
    >
      <Loader2 className="loading-spinner" size={28} aria-hidden />
      <span>Loading…</span>
    </div>
  )
}
